import Phaser from "phaser";
import { buildTextures } from "../ui/textures";

/** Generates all runtime placeholder sprite textures, then hands off to
 *  PreloadScene which loads the file-based assets (tilesets + maps). */
export class BootScene extends Phaser.Scene {
  constructor() {
    super("Boot");
  }

  create() {
    buildTextures(this);
    this.scene.start("Preload");
  }
}
